import { Fragment, useState, FC } from "react";
// import styles from "./BorrowersGraph.module.scss";
import { useRouteMatch } from "react-router-dom";
import useRecentBorrowers from "../../../../../custom-hooks/useRecentBorrowers";
import { formatBorrowerGraphData } from "../../../../../helpers/formatGraphData";
import graphDropdownOptions from "../../../../../helpers/graphDropdownOptions";
import GraphSubTitle from "../GraphComponents/GraphSubTitleSection/GraphSubTitle.component";
import GraphTitleSection from "../GraphComponents/GraphTitleSection/GraphTitleSection.component";
import useDashboardBorrowerGraph from "../../../../../custom-hooks/useBorrowerGraph";
import DoughnutChart from "../Charts/BarChart/DoughnutChart.component";
import EmptyDoughnutChart from "../Charts/BarChart/EmptyDoughnutChart.component";
import ButtonLoader from "../../../../../UI/Loaders/Loaders";

import "./BorrowersGraph.scss";
interface IBorrowersGraph {
  aggregatorId: number;
}

const BorrowersGraph: FC<IBorrowersGraph> = ({ aggregatorId }) => {
  const [filter, setFilter] = useState(graphDropdownOptions.thisYear);
  const match = useRouteMatch();
  const { data, status, error } = useDashboardBorrowerGraph({
    aggregatorId,
    filter,
  });
  const {
    data: recentBorrowersData,
    status: recentBorrowersStatus,
    error: recentBorrowersError,
  } = useRecentBorrowers({ aggregatorId: aggregatorId.toString() });

  //JSX Template
  let RenderedComponent = null;

  if (status === "loading") {
    RenderedComponent = (
      <div className="d-flex justify-content-center align-items-center m-h-100">
        <ButtonLoader />
      </div>
    );
  } else if (error) {
    RenderedComponent = (
      <h5 className="text-danger text-center font-weight-bold">
        An error occurred
      </h5>
    );
  } else if (data) {
    if (!data.data || !data.data.length) {
      RenderedComponent = <EmptyDoughnutChart />;
    } else {
      RenderedComponent = RenderedComponent = (
        <DoughnutChart graphData={formatBorrowerGraphData(data.data)} />
      );
    }
  }

  return (
    <div>
      <div className="card">
        <div className="card-body p-3">
          <GraphTitleSection
            filter={filter}
            setFilter={setFilter}
            title="Borrowers"
          >
            <div></div>

            {/* <div className={styles.alignGraphLabels}>
              <span className={styles.bgActive}>Active</span>
              <span className={styles.bgInActive}>Inactive</span>
            </div> */}
          </GraphTitleSection>
          <Fragment>{RenderedComponent}</Fragment>
        </div>
      </div>
      <div className="card mt-3">
        <div className="card-body p-3">
          <GraphSubTitle
            text="Recent Borrowers"
            to={match.path + "borrowers"}
          />

          <Fragment>
            {recentBorrowersStatus === "loading" ? (
              <div className="d-flex justify-content-center align-items-center m-h-100">
                <ButtonLoader />
              </div>
            ) : recentBorrowersError ? (
              <h5 className="text-danger text-center font-weight-bold">
                An error occurred
              </h5>
            ) : recentBorrowersData && recentBorrowersData.data.length > 0 ? (
              <ul className="dashboard-graph-list">
                {recentBorrowersData.data
                  .slice(0, 3)
                  .map((data: any, _i: number) => {
                    const { isActive, name } = data;
                    return (
                      <li key={_i}>
                        <span className="text-capitalize dashbord-graph-list-name ">
                          {name && name.toLowerCase()}
                        </span>{" "}
                        <span
                          className={`${
                            isActive ? "active" : "inactive"
                          } dashboard-graph-list-amount `}
                        >
                          {isActive ? "Active" : "Inactive"}
                        </span>
                      </li>
                    );
                  })}
              </ul>
            ) : (
              <div>No Data</div>
            )}
          </Fragment>
        </div>
      </div>
    </div>
  );
};
export default BorrowersGraph;
